/* Keep checkout CTA amounts in step with the existing server/app totals. */
(function () {
  if (window.eveCheckoutAmounts) return;
  var sourceSelector = '[data-cart-checkout-source]';
  var amountSelector = '[data-cart-checkout-amount]';
  var relevantSelector = sourceSelector + ', #scDiscountApp, ' + amountSelector;
  var watched = new WeakSet();
  var pendingCart = null;
  var queued = false;

  function cleanText(element) {
    if (!element) return '';
    var copy = element.cloneNode(true);
    copy.querySelectorAll('s, del').forEach(function (node) { node.remove(); });
    return copy.textContent.replace(/\s+/g, ' ').trim();
  }

  function normalizeLabel(value) {
    return (value || '').toLowerCase().replace(/[\s:.]+/g, '');
  }

  function appAmount(scope, button) {
    var app = scope.querySelector('#scDiscountApp');
    if (!app) return '';
    var labels = [button.dataset.checkoutTotalLabel, button.dataset.checkoutSubtotalLabel].map(normalizeLabel).filter(Boolean);
    var rows = app.querySelectorAll('.sc_simple-info__row:not(.sc_code-info)');
    for (var i = rows.length - 1; i >= 0; i--) {
      var row = rows[i];
      if (row.children.length < 2 || labels.indexOf(normalizeLabel(row.firstElementChild.textContent)) === -1) continue;
      var value = cleanText(row.lastElementChild);
      if (/\d/.test(value)) return value;
    }
    return '';
  }

  function update() {
    queued = false;
    if (window.cartMutationPromise && window.cartMutationPromise !== pendingCart) {
      pendingCart = window.cartMutationPromise;
      pendingCart.then(schedule, schedule);
    }
    document.querySelectorAll('[data-cart-checkout]').forEach(function (button) {
      var scope = button.closest('cart-drawer, #main-cart-footer');
      var amount = button.querySelector(amountSelector);
      if (!scope || !amount) return;
      var source = scope.querySelector(sourceSelector);
      var value = appAmount(scope, button) || (source && source.getAttribute('data-cart-checkout-money')) || cleanText(source);
      var pending = !!window.cartMutationPromise || !!scope.querySelector('cart-items[aria-busy="true"], cart-drawer-items[aria-busy="true"]');
      amount.hidden = pending || scope.classList.contains('is-empty') || !/\d/.test(value);
      if (!amount.hidden && amount.textContent !== '· ' + value) amount.textContent = '· ' + value;
    });
  }

  function schedule() {
    if (queued) return;
    queued = true;
    Promise.resolve().then(update);
  }

  function relevant(mutation) {
    var target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
    if (target && target.closest(amountSelector)) return false;
    if (mutation.type === 'attributes') return mutation.attributeName === 'aria-busy' || mutation.target.matches('cart-drawer, #main-cart-footer');
    if (target && target.closest(sourceSelector + ', #scDiscountApp')) return true;
    return Array.prototype.some.call(mutation.addedNodes, containsRelevant) || Array.prototype.some.call(mutation.removedNodes, containsRelevant);
  }

  function containsRelevant(node) {
    return node.nodeType === 1 && (node.matches(relevantSelector) || !!node.querySelector(relevantSelector));
  }

  function start() {
    document.querySelectorAll('cart-drawer, #main-cart-footer').forEach(function (scope) {
      if (watched.has(scope)) return;
      watched.add(scope);
      new MutationObserver(function (mutations) {
        if (mutations.some(relevant)) schedule();
      }).observe(scope, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-busy', 'class'] });
    });
    schedule();
  }

  window.eveCheckoutAmounts = { sync: schedule };
  document.addEventListener('cart:updated', schedule);
  document.addEventListener('shopify:section:load', start);
  window.addEventListener('sc:discount.calculated', schedule);
  window.addEventListener('sc:discount.remove', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
